module.exports = __webpack_public_path__ + "static/media/ico-contrasena-act.c57240ec.svg";